var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", [
    _c("button", { on: { click: _vm.selectChapter } }, [
      _vm._v(_vm._s(_vm.$t(_vm.buttonText.key, _vm.buttonText.attr)))
    ]),
    _c("time", {
      attrs: {
        role: "timer",
        tabindex: "0",
        title: _vm.$t(_vm.timerRemaining.key, _vm.timerRemaining.attr)
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }